import { HTMLAttributes, MouseEvent } from 'react';

/**
 * Card — the standard surface container: raised surface, hairline border,
 * no shadow. Depth comes from the surface step, never a drop shadow.
 */
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Corner radius. Default 'lg' (26px). */
  radius?: 'lg' | 'md' | 'sm';
  /** Adds a gold-hairline + lift hover treatment for clickable cards. */
  interactive?: boolean;
}

export function Card({ radius = 'lg', interactive = false, style, children, ...props }: CardProps) {
  const radii = { lg: 'var(--r-lg)', md: 'var(--r-md)', sm: 'var(--r-sm)' };
  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--line)',
        borderRadius: radii[radius],
        padding: 24,
        transition: interactive
          ? 'border-color .3s cubic-bezier(.16,.8,.3,1), transform .3s cubic-bezier(.16,.8,.3,1)'
          : undefined,
        ...style,
      }}
      onMouseEnter={interactive ? (e: MouseEvent<HTMLDivElement>) => { e.currentTarget.style.borderColor = 'var(--accent-border)'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = 'var(--shadow-hover)'; } : undefined}
      onMouseLeave={interactive ? (e: MouseEvent<HTMLDivElement>) => { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; } : undefined}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
